import type { FormFieldType } from "@tellescope/types-models";
import type { FormTypesWithValues } from "../types";

export type ConvertedFormFieldType = FormTypesWithValues | "Question Group" | null;

export const convertFormFieldType = (type: FormFieldType): ConvertedFormFieldType => {
  switch (type) {
    case "Table Input":
      return "Input Table";
    case "description":
    case "Emotii":
      return null;
    default:
      return type;
  }
};
